"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlannerProvider = exports.usePlannerContext = exports.PlannerContext = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var services_1 = require("../../services");
var enums_1 = require("../../shared/enums");
var config_provider_1 = require("../config/config.provider");
exports.PlannerContext = react_1.default.createContext({});
function usePlannerContext() {
    var ctx = react_1.default.useContext(exports.PlannerContext);
    if (!ctx || !(ctx === null || ctx === void 0 ? void 0 : ctx.toggleTimeoff)) {
        throw new Error("Must be inside 'PlannerProvider'");
    }
    return ctx;
}
exports.usePlannerContext = usePlannerContext;
function PlannerProvider(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f;
    var children = _a.children, defaultContext = _a.defaultContext;
    var configState = react_1.default.useContext(config_provider_1.ConfigContext);
    var otkIdentityService = react_1.default.useCallback(function () { return new services_1.OtkIdentityService(configState.service); }, [configState]);
    var _g = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.students) || []), students = _g[0], setStudents = _g[1];
    var _h = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.activities) || []), activities = _h[0], setActivities = _h[1];
    var _j = react_1.default.useState('allStudents'), selectedStudent = _j[0], setSelectedStudent = _j[1];
    var _k = react_1.default.useState((_c = (_b = defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.activities) === null || _b === void 0 ? void 0 : _b.map(function (a) { return a.activity; })) !== null && _c !== void 0 ? _c : []), selectedActivities = _k[0], setSelectedActivities = _k[1];
    var _l = react_1.default.useState((_d = defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.openTimeoff) !== null && _d !== void 0 ? _d : false), openTimeoff = _l[0], setOpenTimeoff = _l[1];
    var _m = react_1.default.useState((_e = defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.openReschedule) !== null && _e !== void 0 ? _e : false), openReschedule = _m[0], setOpenReschedule = _m[1];
    var _o = react_1.default.useState((_f = defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.openAddEvent) !== null && _f !== void 0 ? _f : false), openAddEvent = _o[0], setOpenAddEvent = _o[1];
    var fetchStudentsCallback = react_1.default.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var schoolUsers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, otkIdentityService().getSchoolUsers()];
                case 1:
                    schoolUsers = _a.sent();
                    setStudents((schoolUsers === null || schoolUsers === void 0 ? void 0 : schoolUsers.filter(function (user) { return user.role === enums_1.IdentityRolesEnum.STUDENT; })) || []);
                    return [2 /*return*/];
            }
        });
    }); }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var fetchActivitiesCallback = react_1.default.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var activityTypes;
        return __generator(this, function (_a) {
            activityTypes = components_1.DefaultActivityFilterOptionsArgs;
            setActivities(activityTypes);
            setSelectedActivities(activityTypes.map(function (activityType) { return activityType.activity; }));
            return [2 /*return*/];
        });
    }); }, []);
    function toggleTimeoff() {
        setOpenTimeoff(!openTimeoff);
    }
    function toggleReschedule() {
        setOpenReschedule(!openReschedule);
    }
    function toggleAddEvent() {
        setOpenAddEvent(!openAddEvent);
    }
    function selectActivities(activities) {
        setSelectedActivities(activities);
    }
    function selectStudent(student) {
        setSelectedStudent(student);
    }
    return (react_1.default.createElement(exports.PlannerContext.Provider, { value: {
            activities: activities,
            fetchActivities: fetchActivitiesCallback,
            fetchStudents: fetchStudentsCallback,
            openAddEvent: openAddEvent,
            openReschedule: openReschedule,
            openTimeoff: openTimeoff,
            selectActivities: selectActivities,
            selectedActivities: selectedActivities,
            selectedStudent: selectedStudent,
            selectStudent: selectStudent,
            students: students,
            toggleAddEvent: toggleAddEvent,
            toggleReschedule: toggleReschedule,
            toggleTimeoff: toggleTimeoff,
        } }, children));
}
exports.PlannerProvider = PlannerProvider;
